// @flow

import React from 'react'

import { classNames } from '../../helpers/strings';

import './PrimaryButton.css';

type PrimaryButtonProps = {
  action: () => void,
  text?: string,
  className?: string,
  id?: string,
  disabled: boolean,
  loading?: boolean,
  isMobileFriendly?: boolean,
};

const PrimaryButton = ({
  action,
  text,
  className = '',
  id = '',
  disabled,
  loading,
  isMobileFriendly,
}: PrimaryButtonProps) => (
  <button
    className={classNames(
      'action pdp-button primary tocart addToCart',
      className,
      !isMobileFriendly ? 'pdp-button--no-mobile' : '',
    )}
    disabled={disabled}
    onClick={action}
  >
    <span className={`button__text ${loading ? 'hide' : ''}`}>{text}</span>
    {loading ? <span className="animate__spinner"><span /></span> : ''}
  </button>
);

PrimaryButton.defaultProps = {
  text: '',
  className: '',
  id: '',
  disabled: false,
  loading: false,
  isMobileFriendly: false,
};

export default PrimaryButton;



// WEBPACK FOOTER //
// ./src/components/PrimaryButton/index.js